function detectBrowser() {
  const ua = navigator.userAgent;
  let tem;
  let M =
    ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) ||
    [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return `IE ${tem[1] || ""}`;
  }
  if (M[1] === "Chrome") {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null) {
      return tem
        .slice(1)
        .join(" ")
        .replace("OPR", "Opera");
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
  // eslint-disable-next-line no-cond-assign
  if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
  return { browser: M[0], version: M[1] };
}

function deviceInfo() {
  return {
    serialNumber: "",
    type:
      window.navigator.appVersion.indexOf("Mobile") !== -1
        ? "smartphone"
        : "PC",
    brandName: detectBrowser().browser,
    model: detectBrowser().version
  };
}

export default { deviceInfo };
